/**
 * Docist Search JavaScript
 * Handles AJAX search functionality with real-time results
 */
(function ($) {
	'use strict';

	// WordPress-style hook system for JavaScript
	var DocistHooks = {
		actions: {},
		filters: {},

		// Add an action hook
		addAction: function (hook, callback, priority) {
			priority = priority || 10;
			if (!this.actions[hook]) {
				this.actions[hook] = [];
			}
			this.actions[hook].push({
				callback: callback,
				priority: priority,
			});
			// Sort by priority (lower numbers = higher priority)
			this.actions[hook].sort(function (a, b) {
				return a.priority - b.priority;
			});
		},

		// Add a filter hook
		addFilter: function (hook, callback, priority) {
			priority = priority || 10;
			if (!this.filters[hook]) {
				this.filters[hook] = [];
			}
			this.filters[hook].push({
				callback: callback,
				priority: priority,
			});
			// Sort by priority (lower numbers = higher priority)
			this.filters[hook].sort(function (a, b) {
				return a.priority - b.priority;
			});
		},

		// Do an action
		doAction: function (hook, data) {
			if (this.actions[hook]) {
				for (var i = 0; i < this.actions[hook].length; i++) {
					this.actions[hook][i].callback(data);
				}
			}
			// Also fire jQuery event for backward compatibility
			$(document).trigger('docist:' + hook, data);
		},

		// Apply a filter
		applyFilters: function (hook, value, data) {
			if (this.filters[hook]) {
				for (var i = 0; i < this.filters[hook].length; i++) {
					value = this.filters[hook][i].callback(value, data);
				}
			}
			return value;
		},

		// Remove an action
		removeAction: function (hook, callback) {
			if (this.actions[hook]) {
				for (var i = this.actions[hook].length - 1; i >= 0; i--) {
					if (this.actions[hook][i].callback === callback) {
						this.actions[hook].splice(i, 1);
					}
				}
			}
		},

		// Remove a filter
		removeFilter: function (hook, callback) {
			if (this.filters[hook]) {
				for (var i = this.filters[hook].length - 1; i >= 0; i--) {
					if (this.filters[hook][i].callback === callback) {
						this.filters[hook].splice(i, 1);
					}
				}
			}
		},
	};

	// Make hooks available globally
	window.DocistHooks = DocistHooks;

	// Search functionality
	var DocistSearch = {
		searchTimeout: null,
		isSearching: false,

		init: function () {
			this.bindEvents();
		},

		bindEvents: function () {
			var self = this;

			// Search input events
			$(document).on('input', '.docist-search__input', function () {
				var query = $(this).val().trim();
				self.handleSearchInput(query);
			});

			// Form submission (prevent default and use AJAX)
			$(document).on('submit', '.docist-search-form', function (e) {
				e.preventDefault();
				var $input = $(this).find('.docist-search__input');
				var query = $input.val().trim();
				if (query) {
					self.performSearch(query);
				}
			});

			// Search button click (fallback)
			$(document).on('click', '.docist-search__button', function (e) {
				e.preventDefault();
				var $input = $(this).closest('.docist-search').find('.docist-search__input');
				var query = $input.val().trim();
				if (query) {
					self.performSearch(query);
				} else {
					// Focus the input if empty
					$input.focus();
				}
			});

			// Close button click
			$(document).on('click', '.docist-search__close', function () {
				self.closeSearch();
			});

			// ESC key to close search
			$(document).on('keydown', function (e) {
				if (e.key === 'Escape') {
					self.closeSearch();
				}
			});

			// Click outside to close (optional, but good UX)
			$(document).on('click', function (e) {
				if (!$(e.target).closest('.docist-search').length) {
					self.closeSearch();
				}
			});
		},

		handleSearchInput: function (query) {
			var self = this;
			var $searchContainer = $('.docist-search__input').closest('.docist-search');
			var $searchButton = $searchContainer.find('.docist-search__button');
			var $closeButton = $searchContainer.find('.docist-search__close');

			// Clear previous timeout
			if (this.searchTimeout) {
				clearTimeout(this.searchTimeout);
			}

			// Show/hide buttons based on input content
			if (query) {
				$searchButton.hide();
				$closeButton.show();
			} else {
				$searchButton.show();
				$closeButton.hide();
				this.closeSearch();
				return;
			}

			// Debounce search (wait 300ms after user stops typing)
			this.searchTimeout = setTimeout(function () {
				if (query.length >= 2) {
					self.performSearch(query);
				}
			}, 300);
		},

		performSearch: function (query) {
			var self = this;
			var $searchContainer = $('.docist-search__input').closest('.docist-search');
			var $results = $searchContainer.find('.docist-search__results');
			var $resultsContent = $searchContainer.find('.docist-search__results-content');
			var $closeButton = $searchContainer.find('.docist-search__close');

			// Show loading state
			$resultsContent.html('<div class="docist-search__loading">Searching...</div>');
			$results.show();
			$closeButton.show();

			// Prevent multiple simultaneous requests
			if (this.isSearching) {
				return;
			}

			this.isSearching = true;

			// Fire action before search
			DocistHooks.doAction('before_search', {
				query: query,
				searchContainer: $searchContainer[0],
			});

			$.ajax({
				url: docist_search.ajax_url,
				type: 'POST',
				data: {
					action: 'docist_search',
					search_term: query,
					nonce: docist_search.nonce,
				},
				success: function (response) {
					self.isSearching = false;

					if (response.success) {
						self.displayResults(response.data, query);
					} else {
						$resultsContent.html('<div class="docist-search__no-results">' + response.data + '</div>');
					}
				},
				error: function () {
					self.isSearching = false;
					$resultsContent.html(
						'<div class="docist-search__no-results">' + docist_search.strings.error + '</div>'
					);
				},
			});
		},

		displayResults: function (data, query) {
			var $searchContainer = $('.docist-search__input').closest('.docist-search');
			var $resultsContent = $searchContainer.find('.docist-search__results-content');
			var $results = $searchContainer.find('.docist-search__results');
			var $input = $searchContainer.find('.docist-search__input');

			// Prepare action data
			var actionData = {
				query: query,
				results: data.results,
				totalResults: data.total,
				timestamp: new Date().toISOString(),
				searchContainer: $searchContainer[0],
			};

			if (data.results && data.results.length > 0) {
				var html = '';

				$.each(data.results, function (index, result) {
					html +=
						'<a href="' + result.url + '" class="docist-search__result-item" role="option" tabindex="0">';
					html += '<div class="docist-search__result-title">' + result.title + '</div>';
					html += '</a>';
				});

				$resultsContent.html(html);
				$results.show();

				// Announce results to screen reader
				this.announceResults(data.results.length);

				// Fire action for search results found
				DocistHooks.doAction('search_results_found', actionData);
			} else {
				$resultsContent.html(
					'<div class="docist-search__no-results">No results found for "' + query + '"</div>'
				);
				$results.show();

				// Announce no results to screen reader
				this.announceResults(0);

				// Fire action for no search results
				DocistHooks.doAction('search_no_results', actionData);
			}
		},

		closeSearch: function () {
			var $searchContainer = $('.docist-search__input').closest('.docist-search');
			var $results = $searchContainer.find('.docist-search__results');
			var $closeButton = $searchContainer.find('.docist-search__close');
			var $searchButton = $searchContainer.find('.docist-search__button');
			var $input = $searchContainer.find('.docist-search__input');

			$results.hide();
			$closeButton.hide();
			$searchButton.show();
			$input.val('');

			// Fire action when search is closed
			DocistHooks.doAction('search_closed', {
				searchContainer: $searchContainer[0],
			});
		},

		announceResults: function (count) {
			var message = count > 0 ? count + ' search results found' : 'No search results found';

			// Create announcement for screen readers
			var announcement = $('<div>')
				.attr('aria-live', 'assertive')
				.attr('aria-atomic', 'true')
				.addClass('sr-only')
				.text(message);

			$('body').append(announcement);

			// Remove after announcement
			setTimeout(function () {
				announcement.remove();
			}, 2000);
		},
	};

	// Initialize when document is ready
	$(document).ready(function () {
		DocistSearch.init();

		// Keyboard navigation
		$(document).on('keydown', '.docist-search__input', function (e) {
			var $searchContainer = $(this).closest('.docist-search');
			var $results = $searchContainer.find('.docist-search__results');
			var $resultItems = $results.find('.docist-search__result-item');

			if (e.key === 'ArrowDown' && $results.is(':visible')) {
				e.preventDefault();
				$resultItems.first().focus();
			} else if (e.key === 'Escape') {
				DocistSearch.closeSearch();
			}
		});

		// Keyboard navigation for result items
		$(document).on('keydown', '.docist-search__result-item', function (e) {
			var $currentItem = $(this);
			var $nextItem = $currentItem.next('.docist-search__result-item');
			var $prevItem = $currentItem.prev('.docist-search__result-item');
			var $searchInput = $currentItem.closest('.docist-search').find('.docist-search__input');

			if (e.key === 'ArrowDown') {
				e.preventDefault();
				if ($nextItem.length) {
					$nextItem.focus();
				}
			} else if (e.key === 'ArrowUp') {
				e.preventDefault();
				if ($prevItem.length) {
					$prevItem.focus();
				} else {
					$searchInput.focus();
				}
			} else if (e.key === 'Escape') {
				DocistSearch.closeSearch();
			}
		});
	});
})(jQuery);
